module.exports = __webpack_public_path__ + "img/vladiyan0.e065682a.png";